export default "__VITE_ASSET__DxBwQleh__"